var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Frame") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "My-Nexar---overhaul",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nexar-Connect---Status",
    transform: "translate(-31, -182)",
    stroke: "#FFFFFF",
    strokeWidth: 1.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    transform: "translate(32, 183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.99984,11.9997 C9.3135,11.9997 11.9997,9.3135 11.9997,5.9998 C11.9997,2.68622 9.3135,0 5.99984,0 C2.68622,0 0,2.68622 0,5.9998 C0,9.3135 2.68622,11.9997 5.99984,11.9997 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 8.3999,
    x2: 6,
    y2: 6,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 3.6001,
    x2: 6.006,
    y2: 3.6001,
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.cb4d4b9b27122c248a4971606a779517.svg";
export { ForwardRef as ReactComponent };